import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgFacebook(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M29 16C29 8.82389 23.1761 3 16 3C8.8239 3 3 8.82389 3 16C3 22.4933 7.75283 27.8754 13.9784 28.8393V19.7487H10.6581V16H13.9784V13.1349C13.9784 9.88156 15.9063 8.07415 18.8785 8.07415C20.2976 8.07415 21.7703 8.34191 21.7703 8.34191V11.5149H20.137C18.517 11.5149 18.0082 12.5324 18.0082 13.5499V15.9866H21.6231L21.0474 19.7353H18.0082V28.8259C24.2472 27.8754 29 22.4933 29 16Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgFacebook);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
